import { cn } from '@/utils/cn';
import { ThHTMLAttributes } from 'react';

export const TableHeaderCell = ({
    className,
    ...props
}: ThHTMLAttributes<HTMLTableCellElement>) => (
    <th
        className={cn(
            'h-12 p-2 text-left align-middle font-medium text-white dark:text-dark whitespace-nowrap font-bold',
            className
        )}
        {...props}
    />
);
